module.exports = __webpack_public_path__ + "img/antes_despues_147.94a4d5d9.png";